<div class="space-y-6">
  <app-page-header
    [backTo]="['/options']"
    backLabel="Retour aux équipements"
  >
    @if (item(); as o) {
      <div slot="actions" class="flex flex-wrap items-center gap-2">
        <a
          [routerLink]="['/options', o.id, 'edit']"
          class="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5"
        >
          Modifier
        </a>
        <button
          type="button"
          (click)="openDelete()"
          class="inline-flex items-center justify-center gap-2 rounded-lg border border-error-300 px-4 py-2 text-sm font-medium text-error-700 transition hover:bg-error-50 dark:border-error-800 dark:text-error-400 dark:hover:bg-error-500/10"
        >
          Supprimer
        </button>
      </div>
    }
  </app-page-header>

  @if (loadError() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="loadError()"
      loadingMessage="Chargement…"
      (retry)="fetch()"
    />
  } @else if (item(); as o) {
    <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex items-center gap-4">
          <span class="flex h-14 w-14 items-center justify-center rounded-xl bg-brand-50 text-base font-semibold text-brand-700 dark:bg-brand-500/15 dark:text-brand-400">
            {{ o.nameFr.slice(0, 2).toUpperCase() }}
          </span>
          <div>
            <h1 class="text-xl font-semibold text-gray-800 dark:text-white/90">{{ o.nameFr }}</h1>
            @if (o.nameEn) {
              <p class="text-sm text-gray-500 dark:text-gray-400">{{ o.nameEn }}</p>
            }
            <p class="font-mono text-xs text-gray-500 dark:text-gray-400">{{ o.slug }}</p>
          </div>
        </div>
        <div class="flex flex-wrap items-center gap-2">
          @if (o.category) {
            <span class="inline-flex h-fit items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-300">
              {{ catLabel[o.category] }}
            </span>
          }
          @if (o.status) {
            <span class="inline-flex h-fit items-center rounded-full bg-brand-50 px-3 py-1 text-xs font-medium text-brand-700 dark:bg-brand-500/15 dark:text-brand-400">Actif</span>
          } @else {
            <span class="inline-flex h-fit items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-300">Inactif</span>
          }
        </div>
      </div>
    </section>

    <div class="grid gap-6 lg:grid-cols-2">
      <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="text-base font-semibold text-gray-800 dark:text-white/90">Identification</h2>
        <dl class="mt-4 grid gap-3 text-sm">
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">Nom français</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">{{ o.nameFr }}</dd>
          </div>
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">Nom anglais</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">{{ o.nameEn || '—' }}</dd>
          </div>
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">Slug (TypeSense)</dt>
            <dd class="text-right font-mono text-xs text-gray-800 dark:text-white/90 break-all">{{ o.slug }}</dd>
          </div>
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">Catégorie</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">
              {{ o.category ? catLabel[o.category] : '—' }}
            </dd>
          </div>
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">Icône</dt>
            <dd class="text-right font-mono text-xs text-gray-800 dark:text-white/90 break-all">{{ o.icon || '—' }}</dd>
          </div>
        </dl>
      </section>

      <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="text-base font-semibold text-gray-800 dark:text-white/90">Métadonnées</h2>
        <dl class="mt-4 grid gap-3 text-sm">
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">ID interne</dt>
            <dd class="text-right font-mono text-gray-800 dark:text-white/90">#{{ o.id }}</dd>
          </div>
          @if (o.entityCode) {
            <div class="flex justify-between gap-4">
              <dt class="text-gray-500 dark:text-gray-400">Code entité</dt>
              <dd class="text-right font-mono text-xs text-gray-800 dark:text-white/90">{{ o.entityCode }}</dd>
            </div>
          }
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">Créé le</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">{{ o.createdAt | ldate:'dd/MM/yyyy HH:mm' }}</dd>
          </div>
          @if (o.updatedAt) {
            <div class="flex justify-between gap-4">
              <dt class="text-gray-500 dark:text-gray-400">Mis à jour</dt>
              <dd class="text-right text-gray-800 dark:text-white/90">{{ o.updatedAt | ldate:'dd/MM/yyyy HH:mm' }}</dd>
            </div>
          }
        </dl>
      </section>
    </div>
  }
</div>

<app-confirm-modal
  [open]="deleteOpen()"
  [busy]="deleting()"
  [error]="deleteError()"
  title="Supprimer cet équipement ?"
  confirmLabel="Supprimer définitivement"
  busyLabel="Suppression…"
  danger
  (confirm)="confirmDelete()"
  (close)="closeDelete()"
>
  L'équipement <strong>{{ item()?.nameFr }}</strong> ne sera plus proposable
  sur les véhicules. Les véhicules qui le référencent déjà conservent le
  lien jusqu'à retrait manuel par leur owner.
</app-confirm-modal>
